import { render, staticRenderFns } from "./exam-folder.vue?vue&type=template&id=55dad6ba&scoped=true&"
import script from "./exam-folder.vue?vue&type=script&lang=ts&"
export * from "./exam-folder.vue?vue&type=script&lang=ts&"
import style0 from "./exam-folder.vue?vue&type=style&index=0&id=55dad6ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55dad6ba",
  null
  
)

export default component.exports